import { defineStore } from "pinia";

export const useLanguageStore = defineStore("language", {
  state: () => ({
    locale: localStorage.getItem("locale") || "en", // 默认英文
  }),
  actions: {
    setLocale(lang) {
      this.locale = lang; // 更新状态
      localStorage.setItem("locale", lang); // 写入 localStorage
    },
    initLocale() {
      if (!localStorage.getItem("locale")) {
        localStorage.setItem("locale", this.locale); // 初始化时写入默认语言
      }
    },
  },
});
